import { render } from "./failPage.vue?vue&type=template&id=62e620ed"
import script from "./failPage.vue?vue&type=script&lang=js"
export * from "./failPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__